export const openNewTab = (url: string) => {
  window.open(url, '_blank');
};
